import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../components/TopBar/styles.css";
import Breadcrumbs from "../../common/breadcrumbs/breadcrumbs.js";
import profileImage from "../../assets/icons/profileImage.png";
import Text from "../../common/typography/text.js";
import Button from "../../common/button/button.js";
import DropdownPortal from "../Utils/DropdownPortal.js";
import { useBreadcrumb } from "../../common/breadcrumbs/breadcrumb-context.js";

//Used for Logout Feature
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthProvider.js";
import ModalView from "../../common/modal/index.js";
import EditableText, {
  MIN_SEARCH_QUERY_LENGTH,
} from "../../common/typography/editableText.js";
import APIService from "../../Service/APIService.js";

const TopBar = () => {
  const {user} = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [universalSearchOpen, setUniversalSearchOpen] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState({});
  const [isSearching, setIsSearching] = useState(false);
  const latestRequestRef = useRef(0);
  const apiServiceRef = useRef(new APIService());
  // const ls = localStorage.getItem("user");

  const name = user.FirstName + " " + user.LastName;

  // const userType = JSON.parse(ls).Type;
  const userType = user.Type;
  const { breadcrumbs } = useBreadcrumb();

  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.logOut();
    // Redirect to the login page
    navigate("/Login");
    console.log("User logged out and redirected to login");
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");

      if (
        (isMac && e.metaKey && e.key.toLowerCase() === "k") ||
        (!isMac && e.ctrlKey && e.key.toLowerCase() === "k")
      ) {
        e.preventDefault();
        setUniversalSearchOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (!universalSearchOpen) {
      setFilteredSuggestions({});
      setIsSearching(false);
    }
  }, [universalSearchOpen]);

  const handleSearch = useCallback(async (query) => {
    const trimmedQuery = query?.trim() ?? "";
    if (trimmedQuery.length < MIN_SEARCH_QUERY_LENGTH) {
      // Invalidate any in-flight request so its response cannot land later.
      latestRequestRef.current += 1;
      setFilteredSuggestions({});
      setIsSearching(false);
      return;
    }

    const requestId = ++latestRequestRef.current;
    setIsSearching(true);

    let results = {};
    try {
      const response = await apiServiceRef.current.getDataFromBackend(
        `universalsearch?q=${encodeURIComponent(trimmedQuery)}&limit=10`
      );
      results = response?.data?.data ?? response?.data ?? {};
    } catch (error) {
      // A failed request must not leave the modal stuck on "Searching...".
      console.error("Universal search failed", error);
      results = {};
    }

    if (requestId !== latestRequestRef.current) return;

    setFilteredSuggestions(results && typeof results === "object" ? results : {});
    setIsSearching(false);
  }, []);

  return (
    <>
      <div className="top-bar">
        <Button
          variant="table"
          subVariant=""
          onClick={() => setUniversalSearchOpen(true)}
          className="blue-background-search-button"
        >
          Search Tissue Vault ⌘ + K
        </Button>
        <div className="top-bar-breadcrumbs">
          <Breadcrumbs items={breadcrumbs} />
        </div>
        <div className="top-bar-profile">
          <div className="top-bar-profile-text">
            <Text variant="bodyText" className="top-bar-text">
              {name}
              <Text
                variant="smallText"
                color="lightText"
                className="top-bar-text"
              >
                {userType}
              </Text>
            </Text>
          </div>
          <div onClick={() => setIsOpen(!isOpen)}>
            <img
              src={profileImage}
              className="profile-image-container"
              alt="Profile"
            ></img>
          </div>
        </div>
        {isOpen && (
          <DropdownPortal>
            <div className="top-bar-menu-dropdown">
              {/* <Button
              variant="table"
              subVariant="primary-hover"
              style={{ width: "100%" }}
            >
              Account
            </Button>
            <Button
              variant="table"
              subVariant="primary-hover"
              style={{ width: "100%" }}
            >
              Settings
            </Button> */}
            <Button
              variant="table"
              subVariant="primary-hover"
              style={{ width: "100%" }}
              onClick={() => {
                setIsOpen(false);
                navigate("/Forgot");
              }}
            >
              Reset Password
            </Button>
            <Button
              variant="table"
              subVariant="failure"
              style={{ width: "100%" }}
              onClick={handleLogout}
            >
              Log Out
            </Button>
            </div>
          </DropdownPortal>
        )}
        {universalSearchOpen && (
          <ModalView
            isOpen={universalSearchOpen}
            onClose={() => setUniversalSearchOpen(false)}
            parentClassname="blue-background-search-button"
            textInputComponent={
              <>
                <EditableText
                  label="Search Input"
                  onSearch={handleSearch}
                  universalSearchOpen={universalSearchOpen}
                  suggestionData={filteredSuggestions}
                  isSearching={isSearching}
                  setUniversalSearchOpen={setUniversalSearchOpen}
                />
              </>
            }
          />
        )}
      </div>
    </>
  );
};

export default TopBar;
